<div class="row">
    <div class="col-3">
        <div class="col-left py-5 px-4">
            <h2 class="mb-4">{{ 'popins.search_customer.title' | translate }}</h2>
            <div class="mt-1">
                <p class="custom-form-row">
                    <label for="input-search-consumer-email">{{ 'popins.search_customer.customer_email' | translate }}</label>
                    <input type="email" [(ngModel)]="inputs.email" name="input-search-consumer-email" id="input-search-consumer-email" autocomplete="email" autocorrect="off" spellcheck="false"/>
                </p>
            </div>
            <div class="pt-2">
                <ng-hbm-bdi-btn class="light-grey" [loading]="isLoading" (click)="search()" [label]="'popins.search_customer.btn' | translate"></ng-hbm-bdi-btn>
            </div>
        </div>
    </div>

    <div class="col-9">
        <div class="header-actions">
            <button class="close" (click)="close()" title="{{ 'generic.close' | translate }}">
                <span class="icon-view-close" aria-hidden="true">
                    <svg>
                        <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
                    </svg>
                </span>
                <span>{{ 'generic.close' | translate }}</span>
            </button>
        </div>

        <div class="modal-content-body">


            <div class="result-container pt-5 pr-3" *ngIf="searchResults">
                <div class="error-text pt-5" *ngIf="searchResults.length === 0" [innerHtml]="requestError"></div>

                <table *ngIf="searchResults.length > 0" class="table result-table">
                    <thead>
                        <tr>
                            <th>
                                <span>{{ 'popins.search_customer.customer_magento_id' | translate }}</span>
                            </th>
                            <th>
                                <span>{{ 'popins.search_customer.customer_fullname' | translate }}</span>
                            </th>
                            <th>
                                <span>{{ 'popins.search_customer.customer_email' | translate }}</span>
                            </th>
                            <th>
                                <span>{{ 'popins.search_customer.customer_hbm_id' | translate }}</span>
                            </th>
                            <th>
                                <span>{{ 'popins.search_customer.customer_status' | translate }}</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let consumer of searchResults" (click)="selectCustomer(consumer)">                            
                            <td>{{ consumer.typeData === 'vendor' ? consumer.userId : consumer.id }}</td>
                            <td>{{ consumer.firstname }} {{ consumer.middlename }} {{  consumer.lastname}}</td>
                            <td>{{ consumer.email }}</td>
                            <td>{{ consumer.hbmId != undefined ? ('generic.yes' | translate) : ('generic.no' | translate) }}</td>
                            <td>{{ consumer.typeData === 'vendor' ? ('popins.search_customer.customer_vendor' | translate) : ('popins.search_customer.customer_customer' | translate) }}</td>
                        </tr>
                    </tbody>
                </table>              
            </div>
        </div>
    </div>
</div>